import requestAction from '../../utils/requestAction'

export const fetchPrepaymentCount = (clientId: string, handleResponse?: (count: number) => void) => 
  requestAction('PREPAYMENT_COUNT')(`prepayments/count?clientId=${clientId}`, 'GET', undefined, undefined, undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.count) })